<template lang="pug">
  Success(
    :src="src"
  )
      | Please check <strong>{{ sentTo }}</strong> for the OnCall Air Finance+ Easy Link and get a decision in seconds.
</template>

<script>
  import Success from '@/components/dialogs/Success'

  export default {
    components: {
      Success,
    },
    props: {
      sentTo: {
        type: String,
        default: null,
      },
      src: {
        type: String,
        default: null
      }
    },
  }
</script>
